import React, { Component } from "react";
import PropTypes from "prop-types";
import Range from "./Range";
import Queue from "./Queue";
import Toolbar from "../../admin/components/Toolbar";
import LaneDrawer from "./LaneDrawer";
import QueueItemDrawer from "./QueueItemDrawer";
import QuickAddDrawer from "./QuickAddDrawer";

import * as firebase from "firebase";

class StaffPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listenerRef: null
    };

    this.loadStaffPage = this.loadStaffPage.bind(this);
    this.clearStaffPage = this.clearStaffPage.bind(this);
  }

  componentWillMount() {
    this.loadStaffPage();
  }

  componentWillUnmount() {
    this.clearStaffPage();
  }

  loadStaffPage() {
    const { rangeLocation, onDataReceived } = this.props;
    const paths = [`ranges/${rangeLocation}`, `queues/${rangeLocation}`];
    const listenerRefs = paths.map(path => {
      const listenerRef = firebase.database().ref(path);
      listenerRef.on("value", snapshot => onDataReceived(path, snapshot.val()));
      return listenerRef;
    });

    this.setState({
      listenerRefs
    });
  }

  clearStaffPage() {
    if (this.state.listenerRefs) {
      this.state.listenerRefs.forEach(listenerRef => listenerRef.off());
    }
  }

  render() {
    const { rangeLocation } = this.props;
    return (
      <div>
        <Toolbar />
        <div className="md-grid" style={{ marginTop: 50 }}>
          <Queue
            className="md-cell md-cell--4 queue-column"
            rangeLocation={rangeLocation}
          />
          <Range className="md-cell md-cell--8 range-column" rangeLocation={rangeLocation} />
        </div>
        <LaneDrawer />
        <QueueItemDrawer />
        <QuickAddDrawer />
      </div>
    );
  }
}

StaffPage.propTypes = {
  rangeLocation: PropTypes.string.isRequired,
  onDataReceived: PropTypes.func.isRequired
};

export default StaffPage;



// WEBPACK FOOTER //
// ./src/staff/components/StaffPage.jsx